import {
  patchState,
  signalStore,
  withComputed,
  withHooks,
  withMethods,
  withState,
  withProps,
} from "@ngrx/signals";
import { computed, effect, inject } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { LanguageCode, LanguageModel } from "../models";
import { languages } from "../constants/languages.constants";

export type LanguageState = {
  languages: LanguageModel[];
  selectedLanguageCode: LanguageCode;
};

const languageKey = "language";
const initialState: LanguageState = {
  languages,
  selectedLanguageCode:
    (localStorage.getItem(languageKey) as LanguageCode) ?? "en",
};

export const LanguageStore = signalStore(
  { providedIn: "root" },
  withState(initialState),
  withComputed((store) => ({
    selectedLanguage: computed(
      () =>
        store
          .languages()
          .find(({ name }) => name === store.selectedLanguageCode()) ??
        languages[0]
    ),
  })),
  withMethods((_store) => ({
    setLanguage(languageCode: LanguageCode) {
      patchState(_store, () => ({ selectedLanguageCode: languageCode }));
    },
  })),
  withProps(() => ({
    translocoService: inject(TranslocoService),
  })),
  withHooks({
    onInit: (store) => {
      effect(() => {
        localStorage.setItem(languageKey, store.selectedLanguageCode());
        store.translocoService.setActiveLang(store.selectedLanguageCode());
      });
    },
  })
);
